var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container p-0" },
    [
      _vm.isEditingCampaign
        ? _c(
            "div",
            { staticClass: "col-12 d-block d-md-none" },
            [
              _c("button-nav", {
                attrs: {
                  buttons: _vm.avalableActions,
                  tooltips: _vm.getTooltips,
                  disable: { activate: _vm.getMpeIssues }
                },
                on: {
                  prevStep: _vm.stepBack,
                  activate: function($event) {
                    return _vm.toggleCampaign("active")
                  },
                  stopCampaign: function($event) {
                    return _vm.toggleCampaign("paused")
                  }
                }
              }),
              _vm._v(" "),
              _c("hr", { staticClass: "mt-0 p-0" })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row m-0 m-0" }, [
        _c(
          "p",
          { staticClass: "col pl-0 pr-0 m-0" },
          [
            _c("span", { staticClass: "float-left centering" }, [
              _c("h4", { staticClass: "break-text campaign-title" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.campaignLabel) + "\n\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _vm.isEditingCampaign
              ? _c("button-nav", {
                  staticClass: "float-right d-none d-sm-none d-md-flex",
                  attrs: {
                    disable: { activate: _vm.getMpeIssues },
                    buttons: _vm.avalableActions,
                    tooltips: _vm.getTooltips
                  },
                  on: {
                    prevStep: _vm.stepBack,
                    activate: function($event) {
                      return _vm.toggleCampaign("active")
                    },
                    stopCampaign: function($event) {
                      return _vm.toggleCampaign("paused")
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "campaign-grid",
        {
          attrs: {
            activeDate: _vm.getViewedDate,
            listItems: _vm.getFilteredMpes,
            removing: _vm.removingEvents,
            defaultStyle: _vm.style,
            today: _vm.getToday,
            minDate: _vm.getEditedCampaignStartDate,
            maxDate: _vm.getEditedCampaignEndDate,
            dateRangePickerPresets: _vm.getDateRangePresets,
            allowRangePicker: "",
            useCalendarNavigation: "",
            dataSource: "mpe",
            variant: "detailed"
          },
          on: {
            changeDate: _vm.setFilteredDate,
            setDisplayStyle: _vm.setDisplayStyle,
            editMpe: _vm.editMpe,
            removeMpe: _vm.removeMpe,
            setSchedule: _vm.setSchedule,
            duplicate: _vm.duplicate
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "break-text date-range-picker-prefix",
              attrs: { slot: "grid-date-prefix" },
              slot: "grid-date-prefix"
            },
            [_vm._v("\n      \n      " + _vm._s(_vm.campaignLabel) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "mpe-filters",
              attrs: {
                slot: "extraFilters",
                "data-v-step": "campaignsView.view.calendar.viewManagement"
              },
              slot: "extraFilters"
            },
            [
              _c("input-select", {
                attrs: {
                  small: "",
                  transparent: "",
                  variant: "standardInput",
                  inputLabel: this.$t("Campaigns.filterType"),
                  inputPlaceholder: this.$t("Button.select"),
                  selectOptions: _vm.mpeTypeFilter,
                  defaultValue: _vm.getTypeFilter,
                  inputName: "mpeTypeFilter"
                },
                on: { fieldUpdate: _vm.setTypeFilter }
              }),
              _vm._v(" "),
              _c("input-select", {
                attrs: {
                  small: "",
                  transparent: "",
                  variant: "standardInput",
                  inputLabel: this.$t("Campaigns.filterChannel"),
                  inputPlaceholder: this.$t("Button.select"),
                  selectOptions: _vm.getChannelOptions,
                  defaultValue: _vm.getChannelFilter,
                  inputName: "getChannelOptions"
                },
                on: { fieldUpdate: _vm.setChannelFilter }
              }),
              _vm._v(" "),
              _vm.areFiltersActive
                ? _c("input-button", {
                    staticClass: "filter-clear-button",
                    attrs: {
                      variant: "standatdInput",
                      btnStyle: "grayed-out-style",
                      inputPlaceholder: this.$t("Campaigns.filterClear")
                    },
                    on: {
                      click: function($event) {
                        return _vm.clearFilters()
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.editing
        ? _c("editor-wrapper", {
            attrs: { mpeId: _vm.editedMpeId },
            on: { discardChanges: _vm.discardChanges, saveMpe: _vm.saveMpe }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 bottom-buttons p-0" },
        [
          _vm.isEditingCampaign
            ? _c("button-nav", {
                attrs: {
                  buttons: _vm.avalableActions,
                  tooltips: _vm.getTooltips,
                  disable: { activate: _vm.getMpeIssues }
                },
                on: {
                  prevStep: _vm.stepBack,
                  activate: function($event) {
                    return _vm.toggleCampaign("active")
                  },
                  stopCampaign: function($event) {
                    return _vm.toggleCampaign("paused")
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-098a66b9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-098a66b9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/campaignManager/CampaignEditor.vue
// module id = null
// module chunks = 